import { Box, Button, Card, Divider, Stack, Typography } from "@mui/material";
import { Edit, Person } from "@mui/icons-material";
import { ShippingAddress } from "../../types";
import { useTranslation } from "../../../../hooks/useTranslation";
import { SectionHeader } from "../../../../components/ui/SectionHeader";

type Props = {
  shippingAddress?: ShippingAddress;
  onEdit: () => void;
};

export const BuyerInfoCard = ({ shippingAddress, onEdit }: Props) => {
  const { translate } = useTranslation("pages.orderDetails");

  return (
    <Card
      elevation={0}
      sx={{
        p: 2.5,
        backgroundColor: (theme) => theme.palette.customBackground.box,
      }}
    >
      {/* HEADER */}
      <SectionHeader
        icon={<Person sx={{ fontSize: 20, color: "secondary.main" }} />}
        title={translate("buyerInfo.title")}
        color="secondary"
        action={
          <Button
            size="small"
            variant="outlined"
            startIcon={<Edit fontSize="small" />}
            onClick={onEdit}
          >
            {translate("addressEdit.button")}
          </Button>
        }
      />

      <Divider sx={{ my: 2 }} />

      {/* CONTENT – LABEL / VALUE */}
      <Stack spacing={1}>
        <Box display="flex">
          <Box width={120}>
            <Typography variant="body2" fontWeight={500}>
              {translate("buyerInfo.name")}
            </Typography>
          </Box>
          <Typography variant="body2">
            {shippingAddress?.name ?? "-"}
          </Typography>
        </Box>

        <Box display="flex">
          <Box width={120}>
            <Typography variant="body2" fontWeight={500}>
              {translate("buyerInfo.phone")}
            </Typography>
          </Box>
          <Typography variant="body2">
            {shippingAddress?.phone ?? "-"}
          </Typography>
        </Box>

        <Box display="flex">
          <Box width={120}>
            <Typography variant="body2" fontWeight={500}>
              {translate("buyerInfo.address")}
            </Typography>
          </Box>
          <Typography variant="body2">
            {[
              shippingAddress?.addressLine1,
              shippingAddress?.addressLine2,
              shippingAddress?.city,
              shippingAddress?.stateOrRegion,
              shippingAddress?.countryCode,
            ]
              .filter(Boolean)
              .join(", ") || "-"}
          </Typography>
        </Box>
      </Stack>
    </Card>
  );
};
